import * as React from 'react';
import { ButtonWithIcon } from '@packages/ui';
import {
  MessageBox,
  ExitButtonContainer,
  StyledImageText,
  StyledCTATile,
  StyledCTAWrapper,
  StyledTitle,
  StyledText,
  StyledImageWrapper,
  StyledUnderlay,
} from './ExitIntentStyledComponents';
import { SmartLink } from '../../SmartLink';

export interface ExitIntentCTATile {
  ctaText: string;
  ctaUrl: string;
  ctaImageUrl: string;
}

export interface ExitIntentProps {
  onClick: VoidFunction;
  handleCloseExitIntent: VoidFunction;
  title: string;
  text: string;
  ctas: ExitIntentCTATile[];
}

export const ExitIntent: React.FC<ExitIntentProps> = ({ title, text, ctas, handleCloseExitIntent }) => {
  return (
    <StyledUnderlay>
      <MessageBox>
        <ExitButtonContainer py={2}>
          <ButtonWithIcon
            padding={0}
            variant="clean"
            iconColor="sandDune"
            iconName="close"
            onClick={handleCloseExitIntent}
          />
        </ExitButtonContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledText>{text}</StyledText>
        {ctas.length > 0 && (
          <StyledCTAWrapper>
            {ctas.map(({ ctaText, ctaUrl, ctaImageUrl }, idx) => {
              return (
                <StyledCTATile key={idx}>
                  <SmartLink linkUrl={ctaUrl} target={'_self'}>
                    <StyledImageWrapper>
                      <img src={ctaImageUrl} height={'80px'} width={'80px'} />
                    </StyledImageWrapper>
                    <StyledImageText>{ctaText}</StyledImageText>
                  </SmartLink>
                </StyledCTATile>
              );
            })}
          </StyledCTAWrapper>
        )}
      </MessageBox>
    </StyledUnderlay>
  );
};
